angular.module('app.filters')
.filter('filterJobsByPQE', [
  '$log', function($log) {
    return function(firmList, selectedPQE) {
      var count, filteredFirms, maxPQE, minPQE, seperator;
      filteredFirms = [];
      seperator = selectedPQE.search(";");
      minPQE = selectedPQE.slice(0, seperator);
      maxPQE = selectedPQE.slice(seperator+1, selectedPQE.length);
      $log.info("selectedPQE",selectedPQE,"minPQE",minPQE,"maxPQE",maxPQE);
      firmList.forEach(function(firm, index, array) {
        firm.selected_jobs = [];
        firm.uniqueJobs = [];
        firm.available_jobs.forEach(function(job, j_index, array) {
          if ((minPQE <= 0 || minPQE === -2 || minPQE === -1) && job.job_exp === "NQ") {
            firm.selected_jobs.push(job);
          } else if (minPQE >= 7 && job.end_exp === 11) {
            firm.selected_jobs.push(job);
          } else if (job.job_exp === "NQ+") {
            firm.selected_jobs.push(job);
          } else if (job.start_exp >= minPQE && job.end_exp <= maxPQE) {
            firm.selected_jobs.push(job);
          } else if ((job.start_exp >= minPQE && (job.start_exp <= maxPQE && job.end_exp != 11)) || (job.start_exp >= minPQE && (job.start_exp <= maxPQE && job.end_exp == 11))) {
            firm.selected_jobs.push(job);
          } else if (job.end_exp >= minPQE && job.end_exp < maxPQE) {
            firm.selected_jobs.push(job);
          } else if ((job.start_exp <= minPQE && job.end_exp >= maxPQE) || (job.start_exp === "NQ" && job.end_exp >= maxPQE)) {
            firm.selected_jobs.push(job);
          }
        });
        firm.uniqueJobs = _.uniq(firm.selected_jobs, 'job_ID');
        firm.available_jobs = angular.copy(firm.uniqueJobs);
      });
      return firmList;
    };
  }
]);


// WEBPACK FOOTER //
// ./scripts/shared/filters/jobs-by-pqe.js